import { IExperimentList } from "@/common/api/services/types";
import { apiExperiments } from "@/common/services";
import { loadExperiments } from "@/common/utils/storage";
import { bus } from "@/common/buses/metrics/bus";

class AssignmentService {
  private requestPromise: Promise<IExperimentList> | null = null;
  private assignments: IExperimentList | null = null;
  private exposures = new Set<string>();

  async get(key: string, fallback: string | boolean): Promise<string | boolean> {
    const localAssignment = loadExperiments()?.[key];

    if (localAssignment !== undefined) {
      this.reportExposure(key, localAssignment);

      return localAssignment;
    }

    try {
      const assignments = await this.getAll();
      const assignment = assignments[key];

      /* No assignment means the user is not enrolled — reporting an exposure here
         would fill the control group with everyone outside the experiment. */
      if (assignment === undefined || assignment === null) {
        return fallback;
      }

      this.reportExposure(key, assignment);

      return assignment;
    } catch (error) {
      console.error(error);

      return fallback;
    }
  }

  private reportExposure(experimentKey: string, experimentVariant: string | boolean) {
    if (this.exposures.has(experimentKey)) {
      return;
    }

    this.exposures.add(experimentKey);

    bus.emit("experimentVariantExposure", { experimentKey, experimentVariant });
  }

  async getAll(): Promise<IExperimentList> {
    if (this.assignments !== null) {
      return this.assignments;
    }

    this.requestPromise = this.requestPromise ?? apiExperiments.getExperiments();
    this.assignments = await this.requestPromise.finally(() => {
      this.requestPromise = null;
    });

    return this.assignments;
  }

  clear() {
    this.requestPromise = null;
    this.assignments = null;
    this.exposures.clear();
  }
}

export default new AssignmentService();
